<h1 mat-dialog-title>{{ result.id ? "Edit" : "Create" }} Organization Group</h1>
<div mat-dialog-content style="display: flex; flex-direction: column; gap: 8px">
    <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="result.name" />
    </mat-form-field>
    <mat-form-field>
        <mat-label>Organizations</mat-label>
        <mat-select [(ngModel)]="result.organizationIds" multiple>
            @for (option of organizations.$editOptions(); track option.state) {
                <mat-option [value]="option.state">{{ option.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    @if (result.id) {
        <button mat-button color="warn" (click)="delete()">Delete</button>
    }
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="accent" (click)="updateOrCreate()">{{ result.id ? "Update" : "Create" }}</button>
</div>
